import { render, staticRenderFns } from "./StockSetting.vue?vue&type=template&id=62564eee&"
import script from "./StockSetting.vue?vue&type=script&lang=ts&"
export * from "./StockSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports